import React from "react";
import {Box} from "@mui/material";
import {Typography} from "../../designSystem/components/Typography";

interface TotalViewProps {
  numberOfData: number;
}

const TotalView = ({
  numberOfData
}: TotalViewProps) => (
  <Box className="p-2 flex flex-col items-center w-[100px]">
    <Typography variant="body" className="text-gray-500">
      顯示筆數
    </Typography>
    <Typography variant="title" className="text-orange-500">
      {numberOfData}
    </Typography>
  </Box>
);

export default TotalView;